import React from 'react';
import paging from '@/hooks/paging';
import { fetchRequestDatasets, toggleRequestDatasetSelected } from '../actions';
import { newRequest, resolveRequestWorkflow } from '../../state/state';

const RequestDatasetsContainer = ({
  category,
  children,
  code,
  fetchData,
  readStatus,
}) => {
  paging.useFetchByCode(fetchData, category, code, readStatus);
  return (<>{children}</>);
};

export const mapStateToProps = ({
  auth: { role: { permissions: { datasets: { create } } } },
  datasets: { newDatasetCode },
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request } = resolveRequestWorkflow(requests, workflows, ownProps, newRequest(ownProps));
  const { datasets } = request.steps;

  return ({
    canCreate: create,
    currentPage: datasets.currentPage,
    filterTerm: datasets.filter,
    datasets: datasets.results,
    newDatasetCode,
    pageCount: datasets.totalPages,
    pageSize: datasets.pageSize,
    readStatus: datasets.readStatus,
    readErrors: datasets.readErrors,
    total: datasets.count,
  });
};

export const mapDispatchToProps = {
  fetchData: fetchRequestDatasets,
  onCheckBoxClick: toggleRequestDatasetSelected,
};

export default RequestDatasetsContainer;
